import { render, staticRenderFns } from "./TouchpointCustomField.vue?vue&type=template&id=696f07e0&"
import script from "./TouchpointCustomField.vue?vue&type=script&lang=js&"
export * from "./TouchpointCustomField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Projects\\Werk\\MarketingDbNEW\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('696f07e0')) {
      api.createRecord('696f07e0', component.options)
    } else {
      api.reload('696f07e0', component.options)
    }
    module.hot.accept("./TouchpointCustomField.vue?vue&type=template&id=696f07e0&", function () {
      api.rerender('696f07e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/BrickSettings/Touchpoint/TouchpointCustomField.vue"
export default component.exports